import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Config from '../../config/config';
import { sortedDataMessages, deleteMessageReducer, addMessageReducer } from "../MainVIew/Messages/messageslice";
import { sortedDataFinishedQuizes, getUserTasks, getUserCreatorTasks, 
    deleteGroupContactFromTask, getPublicTasks, getPrivateTasks } from "../MainVIew/Tasks/taskSlice";

    //import { useNavigate } from "react-router-dom";



const serverPath = Config.serverPath;

//FOR TEST
/*
    const mesDataTest = [{
        id:1,
        userId:48,
        contact:{id:47,nickName:'12323', avatarName:''},
        title:'СП63.13330.2018',
        text:'Look',
        data:'24.02.24',
        mesCategory:2,
        mesHref:1,
        itemId:41,
        read:true,
    },
    {
        id:4,
        userId:10000,
        contact:{id:47,nickName:'12323', avatarName:''},
        title:'Приветствие!',
        text:'Мы рады Вас видеть на нашем сайте!',
        data:'07.07.24',
        mesCategory:1,
        mesHref:6,
        itemId:41,
        read:false,
    },
    {
        id:3,
        userId:47,
        contact:{id:48,nickName:'3413123', avatarName:''},
        title:'СП45.13330.2018',
        text:'Look',
        data:'25.03.24',
        mesCategory:2,
        mesHref:1,
        itemId:41,
        read:false,
    },
    {
        id:2,
        userId:48,
        contact:{id:47,nickName:'12323', avatarName:''},
        title:'СП4555.13330.2018',
        text:'Look!!!!!!!!!',
        data:'21.03.23',
        mesCategory:2,
        mesHref:1,
        itemId:41,
        read:false,
    }];

*/




/////


export const registerUser = createAsyncThunk(
"auth/registerUser", async(item) => {
   // console.log(item);
   
    const url = serverPath + "/api/auth/registration/";
    const urlToFetch = `${url}`;
    const response = await fetch(urlToFetch, {
        method: 'POST',
        headers: {"Content-Type": "application/json; charset=utf-8"},
        body: JSON.stringify({
            useremail: item.email,
            user_password: item.password,
            user_nickname: item.nickname
        }),
        credentials: 'include',
        mode: 'cors',


    });
    
    if (response.ok) {
        const answer = await response.json();
        console.log('Успех:', JSON.stringify(answer));
       // console.log(answer.user);
        return answer;
    } else {
        //console.log(JSON.stringify(await response.json()));
        //console.log(await response.json());
       const answer = await response.json();
        console.log(answer.message);
        console.log(response);
        return response.status;
       // console.log(response.status);
       // console.log(response)
    }


}
);


//LOGOUT

export const logout = createAsyncThunk(
    "auth/logout", async() => {

       
        const url = serverPath + "/api/auth/logout/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'GET',
            headers: {"Content-Type": "application/json; charset=utf-8"},
           
            credentials: 'include',
            mode: 'cors',
        });
        console.log(response.ok);
        if (response.ok) {
            console.log("Успех LOGOUT");
        } else {
           
           console.log('BAD LOGOUT');
         return response.status;
         }
        }
    );
   
    //LOGIN
export const loginUser = createAsyncThunk(
        
    "auth/loginUser", async(item, thunkApi) => {
        // console.log(item);
        const {dispatch} = thunkApi; //FOR TASK SLICE

         const url = serverPath + "/api/auth/login/";
         const urlToFetch = `${url}`;
         const response = await fetch(urlToFetch, {
             method: 'POST',
             headers: {"Content-Type": "application/json; charset=utf-8"},
             body: JSON.stringify({
                 useremail: item.email,
                 user_password: item.password
             }),
             
            credentials: 'include',
            mode: 'cors',
         });
         if (response.ok) {
             const answer = await response.json();

             // ADD FINISHED QUIZES TO TASKSLICE
             dispatch(sortedDataFinishedQuizes(answer.finishedQuizes));

             //ADD USER TASKS TO TASKSLICE
             dispatch(getUserTasks(answer.userTasks));
             dispatch(getUserCreatorTasks(answer.userCreatorTasks));
             dispatch(getPublicTasks(answer.tasksPublic));
             dispatch(getPrivateTasks(answer.tasksPrivate));
             

             console.log('Успех:ЛОГИН', JSON.stringify(answer));
             
             return answer;
         } else {
             //console.log(JSON.stringify(await response.json()));
             //console.log(await response.json());
            const answer = await response.json();
             console.log(answer.message);
             return response.status;
            // console.log(response.status);
            // console.log(response)
         }
     
     
     }
    );

//REFRESH

 export const refreshToken = createAsyncThunk(
    "auth/refreshToken", async(nullArg, thunkApi) => {
        console.log('REFRESH FETCH!');
        const {dispatch} = thunkApi; //FOR TASK SLICE
        const url = serverPath + "/api/auth/refresh/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                
            },
           
            credentials: 'include',
            mode: 'cors',
        });
        console.log(response.ok);
        console.log(response);
        if (response.ok) {
            const answer = await response.json()
            console.log(answer.accessToken);
            // ADD FINISHED QUIZES TO TASKSLICE
            dispatch(sortedDataFinishedQuizes(answer.finishedQuizes));

            //ADD USER TASKS TO TASKSLICE
            dispatch(getUserTasks(answer.userTasks));
            dispatch(getUserCreatorTasks(answer.userCreatorTasks));
            dispatch(getPublicTasks(answer.tasksPublic));
            dispatch(getPrivateTasks(answer.tasksPrivate));
           
            
            console.log("Успех REFRESH", JSON.stringify(answer));
       
           return answer;
        } else {
           
           console.log('BAD REFRESH');
         return response.status;
         }
         
        }
    
);


export const refreshAccessToken = createAsyncThunk(
    "auth/refreshAccessToken", async() => {
        
        
        const url = serverPath + "/api/auth/refreshaccess/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                
            },
           
            credentials: 'include',
            mode: 'cors',
        });
        console.log(response.ok);
        console.log(response);
        if (response.ok) {
            const answer = await response.json()
           // console.log(answer.accessToken);
            console.log("Успех REFRESH ACCESS", JSON.stringify(answer));
       
           return answer;
        } else {
           
           console.log('BAD REFRESH ACCESS');
         return response.ok;
         }
         
        }
    
);
    //RECOVERY
export const recoveryUser = createAsyncThunk(
        
    "auth/recoveryUser", async(item, thunkApi) => {
        // console.log(item);
        const {dispatch} = thunkApi; //FOR TASK SLICE

         const url = serverPath + "/api/auth/recovery/";
         const urlToFetch = `${url}`;
         const response = await fetch(urlToFetch, {
             method: 'POST',
             headers: {"Content-Type": "application/json; charset=utf-8"},
             body: JSON.stringify({
                 useremail: item.email,
                
             }),
             
            credentials: 'include',
            mode: 'cors',
         });
         if (response.ok) {
             const answer = await response.json();


             console.log('Успех:Отправки почты для восстановления', JSON.stringify(answer));
             
             return answer;
         } else {
             
            const answer = await response.json();
             console.log(answer.message);
             return response.status;
            // console.log(response.status);
            // console.log(response)
         }
     
     
     }
    );

        //RECOVERY PASS  !!! dont used
export const recoveryUserPass = createAsyncThunk(
        
    "auth/recoveryUserPass", async(item, thunkApi) => {
        // console.log(item);
        const {dispatch} = thunkApi; //FOR TASK SLICE

         const url = serverPath + "/api/auth/recoverypass/";
         const urlToFetch = `${url}`;
         const response = await fetch(urlToFetch, {
             method: 'POST',
             headers: {"Content-Type": "application/json; charset=utf-8"},
             body: JSON.stringify({
                 userPassword: item.password,
                
             }),
             
            credentials: 'include',
            mode: 'cors',
         });
         if (response.ok) {
             const answer = await response.json();


             console.log('Успех:Отправки почты для восстановления', JSON.stringify(answer));
             
             return answer;
         } else {
             
            const answer = await response.json();
             console.log(answer.message);
             return response.status;
            // console.log(response.status);
            // console.log(response)
         }
     
     
     }
    );

        //RECOVERY PASS FORM
export const recoveryUserPassForm = createAsyncThunk(
        
    "auth/recoveryUserPassForm", async(item, thunkApi) => {
        // console.log(item);
        const {dispatch} = thunkApi; //FOR TASK SLICE

         const url = serverPath + "/api/auth/recoverypass/reset";
         const urlToFetch = `${url}`;
         const response = await fetch(urlToFetch, {
             method: 'POST',
             headers: {"Content-Type": "application/json; charset=utf-8"},
              body: JSON.stringify({
                 userPassword: item.userPassword,
                
             }),           
            credentials: 'include',
            mode: 'cors',
         });

         //const navigate = useNavigate();
         if (response.ok) {
             const answer = await response.json();


             console.log('Успех', JSON.stringify(answer));
             
             return answer;
            
           // navigate('/');


           // return <Navigate to="/" />




         } else {
             
            const answer = await response.json();
             console.log(answer.message);
             return response.status;
            // console.log(response.status);
            // console.log(response)
         }
     
     
     }
    );


//UPDATE ACCOUNT

export const accountUpdate = createAsyncThunk(
    "auth/accountUpdate", async(item, thunkApi) => {
        console.log(item);
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/updateuser/";
        const urlToFetch = `${url}${item.id}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                id: item.id,
                username: item.username,
                id_occupation: item.id_occupation,
                usercountry: item.usercountry,
                publisher: item.publisher
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(accountUpdate(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            } 
        }  
        else {
            console.log(response);
        }

    }
);


//ADD FAVORITE QUIZES
    export const addFavoriteQuizes = createAsyncThunk(
        
        "auth/addFavoriteQuizes", async(item, thunkApi) => {
            // console.log(item);
            const {dispatch} = thunkApi;
             const url = serverPath + "/api/favoritequizes/add";
             const urlToFetch = `${url}`;
             const response = await fetch(urlToFetch, {
                 method: 'POST',
                 headers: {"Content-Type": "application/json; charset=utf-8",
                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                },
                 body: JSON.stringify({
                     user_id: item.user_id,
                     quiz_id: item.quiz_id,
                     
                 }),
                 
                credentials: 'include',
                mode: 'cors',
             });
             if (response.ok) {
                 const answer = await response.json();
                 
                 console.log('Успех:ADD FAVORITES', JSON.stringify(answer));
                 
                 return answer;
             } 
             else if (response.status === 401) {
          
                console.log('401 -refresh access token!');
                try {
                    const result = await dispatch(refreshAccessToken());
                  //IF ACCESS AND REFRESH TOKEN BAD
                    console.log(result.payload);
                    if (result.payload) {
                      dispatch(addFavoriteQuizes(item));
                    } else {
                        console.log('Bad refresh access');
                    }
                } catch (e) {
                    console.log('Error');
                }
            } 
             else {
                 //const answer = await response.json();
                 //console.log(answer.message);
                 return response.status;
                // console.log(response.status);
                // console.log(response)
             }
         
         
         }
        );
//DELETE    FAVORITE QUIZES
export const deleteFavoriteQuizes = createAsyncThunk(
    "auth/deleteFavoriteQuizes", async(data, thunkApi) => {
        console.log(data);
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/favoritequizes/delete/";
        //const urlToFetch = `${url}${28}/${11}`;
        const urlToFetch = `${url}${data.user_id}/${data.quiz_id}`;
        console.log(urlToFetch);
        console.log(data);
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            credentials: 'include',
            mode: 'cors',
        }) ;
        console.log(response.ok);
        console.log(response);
        if (response.ok) {
            const answer = await response.json()
            
            console.log("Успех DELETE FAV QUIZ", JSON.stringify(answer));
           
           return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(deleteFavoriteQuizes(data));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        
        }
        else {
           
           console.log('BAD DELETE FAV QUIZ');
         return response.status;
         }   
    }
);        
//ADD QUIZE RESULT
export const addQuizResult = createAsyncThunk(
    "auth/addQuizResult", async(data, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(data);
        const url = serverPath + "/api/addresult/";
        const urlToFetch = `${url}`;
        //const urlToFetch = `${url}${data.user_id}/${data.quiz_id}`;
        //console.log(urlToFetch);
        console.log(data);
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                user_id: data.user_id,
                quiz_id: data.quiz_id,
                quiz_resolved: data.quiz_resolved,
                dataQuestionsResult: data.dataQuestionsResult
            }),
            credentials: 'include',
            mode: 'cors',
        }) ;
        console.log(response.ok);
        console.log(response);
        if (response.ok) {
            const answer = await response.json()
            
            console.log("Успех ADD RESULT QUIZ", JSON.stringify(answer));
           
           return answer;
        } 
        else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(addQuizResult(data));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } 
        else {
           
           console.log('BAD ADD FRESULT QUIZ');
         return response.status;
         }   
    }

);
//ADD USER SCORE RESULT -NO USE
/*
export const addUserScore = createAsyncThunk(
    "auth/addUserScore", async(data, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(data);
        const url = serverPath + "/api/adduserscore/";
        const urlToFetch = `${url}`;
        //const urlToFetch = `${url}${data.user_id}/${data.quiz_id}`;
        //console.log(urlToFetch);
        console.log(data);
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                user_id: data.user_id,
                quiz_id: data.quiz_id,
                }),
            credentials: 'include',
            mode: 'cors',
        }) ;
        console.log(response.ok);
        console.log(response);
        if (response.ok) {
            const answer = await response.json()
            
            console.log("Успех ADD SCORE ", JSON.stringify(answer));
           
           return answer;
        } 
        //do not need include reacting on the 401 error
        else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
              
                  dispatch(addUserScore(data));
              
            } catch (e) {
                console.log('Error');
            }
        } else {
           
           console.log('BAD ADD SCORE');
         return response.status;
         }   
    }
    
);
*/
//UPLOAD AVATAR

export const uploadAvatar = createAsyncThunk(
    "auth/uploadAvatar", async(item, thunkApi) => {
       console.log(item);
       const {dispatch} = thunkApi;
        const url = serverPath + "/api/uploads/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
          headers: {
           // "Content-Type": "multipart/form-data  "
        "Authorization": `Bearer ${localStorage.getItem('token')}`,
        },
          
            body: item,
            credentials: 'include',
            mode: 'cors',
        });
        
        if (response.ok) {
            const answer = await response.json();
            console.log('Успех Upload:', JSON.stringify(answer));
           // console.log(answer.user);
           
            return answer;
        } 
        //REFRESH ACCESS TOKEN IF 401

         else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
               console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(uploadAvatar(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        }
        else {
    
           const answer = await response.json();
            console.log(answer.message);
    
            console.log(response);
            return response.status;
           // console.log(response.status);
           // console.log(response)
        }
    
    
    }
    );
//DELETE    AVATAR
export const deleteAvatar = createAsyncThunk(
    "auth/deleteAvatar", async(data, thunkApi) => {
        console.log(data);
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/avatar/";
        const urlToFetch = `${url}${data.userId}/${data.imageName}`;
        //const urlToFetch = `${url}${data.user_id}/${data.quiz_id}`;
        console.log(urlToFetch);
        console.log(data);
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            credentials: 'include',
            mode: 'cors',
        }) ;
        console.log(response.ok);
        console.log(response);
        if (response.ok) {
           //
            const answer = await response.json()
            
           console.log("Успех DELETE AVATAR", JSON.stringify(answer));
           // console.log("Успех DELETE AVATAR");
           
          // return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(deleteAvatar(data));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {
           
           console.log('BAD DELETE AVATAR');
         return response.status;
         }   
    }
); 
//FIND CONTACT

export const findContact = createAsyncThunk(
    "auth/findContact", async(nickName, thunkApi) => {
        
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/contacts/";
        const urlToFetch = `${url}${nickName}`;
        const response = await fetch(urlToFetch, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
           
            credentials: 'include',
            mode: 'cors',
        });
        console.log(response.ok);
        console.log(response);
        if (response.ok) {
            const result = await response.json()
            
            console.log("Успех FIND CONTACT", JSON.stringify(result));
           
           return result;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(findContact(nickName));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {
           
           console.log('BAD FIND CONTACTS');
         return response.status;
         }
         
        }
    
);

//DELETE    CONTACT
export const deleteContact = createAsyncThunk(
    "auth/deleteContact", async(data, thunkApi) => {
        console.log(data);
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/deletecontacts/";
        //const urlToFetch = `${url}${28}/${11}`;
        const urlToFetch = `${url}${data.userId}/${data.contactId}`;
        console.log(urlToFetch);
        console.log(data);
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            credentials: 'include',
            mode: 'cors',
        }) ;
        console.log(response.ok);
        console.log(response);
        if (response.ok) {
            const answer = await response.json()
            
            console.log("Успех DELETE CONTACT", JSON.stringify(answer));
           
           return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(deleteContact(data));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            } 
        } else {
           
           console.log('BAD DELETE CONTACT');
         return response.status;
         }   
    }
); 

// ADD CONTACT
export const addContact = createAsyncThunk(
    "auth/addContact", async(data, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(data);
        const url = serverPath + "/api/addcontacts/";
        const urlToFetch = `${url}`;
        
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                userId: data.userId,
                contactId: data.contactId,
                }),
            credentials: 'include',
            mode: 'cors',
        }) ;
        console.log(response.ok);
        console.log(response);
        if (response.ok) {
            const answer = await response.json()
            
            console.log("Успех ADD CONTACT ", JSON.stringify(answer));
           
           return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(addContact(data));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {
           
           console.log('BAD ADD CONTACT');
         return response.status;
         }   
    }
);
//CONFIRM CONTACT

export const confirmContact = createAsyncThunk(
    "auth/confirmContact", async(item, thunkApi) => {
        console.log(item);
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/confirmcontact/";
        const urlToFetch = `${url}${item.userId}/${item.contactId}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: 
            {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
                  },
            credentials: 'include',
            mode: 'cors',
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех CONFIRM CONTACT:', JSON.stringify(answer));
           console.log(answer);
           return answer;
        } 
        
        else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(confirmContact(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
                
        } 
            else {
            console.log('BAD CONFIRM CONTACT');
            return response.status;
        }
    }
);
// ADD MESSAGE

export const addMessage = createAsyncThunk(
    "auth/addMessage", async(data, thunkApi) => {
        console.log(data);
        const url = serverPath + "/api/messages/add/";
        const urlToFetch = `${url}`;

        const {dispatch} = thunkApi; //FOR MESSAGE SLICE

        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                userId: data.userId,
                contactId: data.contactId,
                title: data.title,
                text: data.text,
                mesHref: data.mesHref,
                itemId: data.itemId,
                notePart: data.notePart,
                mesCategory: data.mesCategory,
                }),
            credentials: 'include',
            mode: 'cors',
        }) ;
        console.log(response.ok);
        console.log(response);
        if (response.ok) {
            const answer = await response.json()
            
            console.log("Успех ADD MESSAGE ", JSON.stringify(answer));
           dispatch(addMessageReducer(answer));

           return answer;
        } //REFRESH ACCESS TOKEN IF 401

        else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(addMessage(data));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            } 
        }
            else {
           
           console.log('BAD ADD MESSAGE');
         return response.status;
         }   
    }
);

//GET ALL MESSAGES
export const getAllMessages = createAsyncThunk(
    "auth/getAllMessages", async(userId, thunkApi) => {
        
        const {dispatch} = thunkApi; //FOR MESSAGE SLICE

        const url = serverPath + '/api/messages/get/'+`${userId}`;
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
           
            credentials: 'include',
            mode: 'cors',
        });
        console.log(response.ok);
        console.log(response);

/* DO NOT WORK
        const  refreshAccessTokenFunc = async(func, item) => {
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(func(item));
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(getAllMessages(userId));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        }
*/





        if (response.ok) {
            const answer = await response.json()
            
            console.log("Успех GET ALL MESSAGES", JSON.stringify(answer));

            //ADD DATA TO MESSAGE SLICE
            const dataForMessages = {
                data: answer,
                userId: userId,
            }
           // console.log(dataForMessages);
           dispatch(sortedDataMessages(dataForMessages));

            /////////////////
           return answer;
        }  
        
        //REFRESH ACCESS TOKEN IF 401

        else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(getAllMessages(userId));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };


          // const ans = await refreshAccessTokenFunc(getAllMessages, userId);
         //  console.log(ans);

        } else {
           
           console.log('BAD GET ALL MESSAGES');
         return response.status;
         }
         
        }
     
);


//DELETE    MESSAGE
export const deleteMessage= createAsyncThunk(
    "auth/deleteMessage", async(data, thunkApi) => {

        const {dispatch} = thunkApi; //FOR MESSAGE SLICE

        console.log(data);
        const url = serverPath + "/api/messages/";
        //const urlToFetch = `${url}${28}/${11}`;
        const urlToFetch = `${url}${data.userId}/${data.messageId}`;
        console.log(urlToFetch);
        console.log(data);

        

        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            credentials: 'include',
            mode: 'cors',
        }) ;
        console.log(response.ok);
        console.log(response);
        if (response.ok) {
            const answer = await response.json()
            console.log(answer);
            dispatch(deleteMessageReducer(answer.id));

            console.log("Успех DELETE MESSAGE", JSON.stringify(answer));
           
           return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(deleteMessage(data));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {
           
           console.log('BAD DELETE MESSAGE');
         return response.status;
         }   
    }
)
// ADD GROUP CONTACT
export const addGroupContact = createAsyncThunk(
    "auth/addGroupContact", async(data, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(data);
        const url = serverPath + "/api/contactsgroup/addgroup/";
        const urlToFetch = `${url}`;
        
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                userId: data.userId,
                nameGroup: data.nameGroup,
                }),
            credentials: 'include',
            mode: 'cors',
        }) ;
        console.log(response.ok);
        console.log(response);
        if (response.ok) {
            const answer = await response.json()
            
            console.log("Успех ADD GROUP CONTACT ", JSON.stringify(answer));
           
           return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(addGroupContact(data));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {
           
           console.log('BAD ADD GROUP CONTACT');
         return response.status;
         }   
    }
);
//DELETE   GROUP CONTACT
export const deleteGroupContact = createAsyncThunk(
    "auth/deleteGroupContact", async(data, thunkApi) => {
        console.log(data);
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/contactsgroup/deletegroup";
        //const urlToFetch = `${url}${28}/${11}`;
        const urlToFetch = `${url}/${data.groupId}`;
        console.log(urlToFetch);
      //  console.log(data);
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            credentials: 'include',
            mode: 'cors',
        }) ;
        console.log(response.ok);
        console.log(response);
        if (response.ok) {
            const answer = await response.json()
            
            console.log("Успех DELETE GROUP CONTACT", JSON.stringify(answer));

            //DELETE GROUP FROM TASKS
            dispatch(deleteGroupContactFromTask(answer));
           
           return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(deleteGroupContact(data));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            } 
        } else {
           
           console.log('BAD DELETE GROUP CONTACT');
         return response.status;
         }   
    }
);
//UPDATE NAME
export const updateNameGroupContact = createAsyncThunk(
    "auth/updateNameGroupContact", async(item, thunkApi) => {
        console.log(item);
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/contactsgroup/updatenamegroup";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                nameGroup: item.nameGroup,
                groupId: item.groupId,
                
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
           // console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(updateNameGroupContact(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            } 
        }  
        else {
            console.log(response);
        }

    }
);
// ADD USER TO GROUP CONTACT
export const addUserGroupContact = createAsyncThunk(
    "auth/addUserGroupContact", async(data, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(data);
        const url = serverPath + "/api/contactsgroup/adduser/";
        const urlToFetch = `${url}`;
        
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                userId: data.userId,
                groupId: data.groupId,
                }),
            credentials: 'include',
            mode: 'cors',
        }) ;
        console.log(response.ok);
        console.log(response);
        if (response.ok) {
            const answer = await response.json()
            
            console.log("Успех ADD GROUP CONTACT ", JSON.stringify(answer));
           
           return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(addUserGroupContact(data));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {
           
           console.log('BAD ADD GROUP CONTACT');
         return response.status;
         }   
    }
);
//DELETE   USER FROM GROUP
export const userDeleteFromGroup = createAsyncThunk(
    "auth/userDeleteFromGroup", async(item, thunkApi) => {
        console.log(item);
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/contactsgroup/deleteuser/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({
                
                userId: item.userId,
                groupId: item.groupId
                  
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer);
           return answer[0];
            //REFRESH ACCESS TOKEN IF 401

          } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(userDeleteFromGroup(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        } else {console.log(response);}

    }
); 

//INITIAL STATE BEGINNING
const initialState ={
            
            id:'',
            nickName:'',
            avatarName: {user_image_name:''},
            email:'',
            username:'',
            occupation:'',
            usercountry:'',
            subscription:'',
            id_occupation:'',
            password:'',
            userRole:'',
            openRegistrationForm: false,
            openLoginForm: false,
            openActivationForm: false,
            openMainData: false,
            openRecoveryForm: false,
            openRecoveryPassForm: false,
            errorMessage:'',
            errorMessageEmail:'',
            errorMessagePassword:'',
            errorMessageGroupContact: '',
            errorMessageUserGroupContact: '',
            userMessage:'',
            userMessageForRecovery:'',
            accessToken:'',
            refreshToken:'',
            isFetchingStatusForRefresh:false,
            isActivated: false,
            favoriteQuizes:[],
            finishedQuizes:[],
            w_score:0,
            s_score:0,
            c_score:0,
    
            w_total: 10000,
            s_total:10000,
            c_total:10000,
    
            sumQuizes:0,
            quizes_total: 0,

            contacts:[
                {nickname:'man234', avatarname:''},
                
            ],
            contactsGroups: [
                {
                
                groupName:'Main sup 123',
                contacts:[
                    {username:'check1', nickname:'man2345', avatarname:'',id:990000,confirmed:true},
                    {username:'check2',nickname:'man23423232', avatarname:'',id:990001, confirmed:false},
                    
                    ]
                 },
                 {
                    groupName:'sec sup 222',
                    contacts:[
                        {nickname:'swer222234', avatarname:''},
                        {nickname:'msdsdsan234', avatarname:''},
                        
                        ]
                     }
            ],
            findContact:[],
            messages: [],
            usermesCategory:'',
            tasksPublic:[],
            tasksPrivate:[],
            modulesName:[]
    
};


const options ={
    name: 'auth',
    initialState: {
        id:'', //временно для доступа первой страницы,
        nickName:'',
        avatarName: {user_image_name:''},
        email:'',
        username:'',
        occupation:'',
        id_occupation:'',
        subscription:'',
        usercountry:'',
        password:'',
        userRole:'',
        openRegistrationForm: false,
        openLoginForm: false,
        openActivationForm: false,
        openRecoveryForm: false,
        openRecoveryPassForm: false,

        errorMessage:'',
        errorMessageEmail:'',
        errorMessagePassword:'',
        errorMessageNickname:'',
        userMessage:'',
        userMessageForRecovery:'',
        errorMessageGroupContact: '',
        errorMessageUserGroupContact: '',
        accessToken:'',
        refreshToken:'',
        isFetchingStatusForRefresh:false,
        isActivated: false,

        favoriteQuizes:[],
        finishedQuizes:[],

        w_score:0,
        s_score:0,
        c_score:0,

        w_total: 10000,
        s_total:10000,
        c_total:10000,

        sumQuizes:0,
        quizes_total: 0,

        contacts:[
            {username:'check1', nickname:'man2345555', avatarname:'',id:990000,confirmed:true},
            {username:'check2',nickname:'man23423232', avatarname:'',id:990001, confirmed:false},
            
            ],
        contactsGroups: [
            {
                
                groupName:'Main sup 123',
                contacts:[
                    {nickname:'man2345555', avatarname:''},
                    {nickname:'man23423232', avatarname:''},
                    
                    ]
                 },
                 {
                    groupName:'sec sup 222',
                    contacts:[
                        {nickname:'swer222234', avatarname:''},
                        {nickname:'msdsdsan234', avatarname:''},
                        
                        ]
                     }
        ],
        findContact:[],
        messages: [],
        usermesCategory:'',
        tasksPublic:[],
        tasksPrivate:[],
        modulesName:[]

    },
    reducers: {
         // GET first INITIAL STATE
         getInitialState: state  => 
         initialState,
       
        openRegistrationForm: (state,action) => {
            state.openRegistrationForm = true;
        },
        closeRegistrationForm: (state,action) => {
            state.openRegistrationForm = false;
            state.errorMessage = "";
            state.errorMessageEmail = "";
            state.errorMessagePassword = "";

        },
        closeLoginForm: (state,action) => {
            state.openLoginForm = false;
            state.errorMessage = "";
            state.errorMessageEmail = "";
            state.errorMessagePassword = "";
        },
        openRecoveryForm: (state, action) => {
            state.openRecoveryForm = true;
        },
        closeRecoveryForm: (state,action) => {
            state.openRecoveryForm = false;
            state.errorMessage = "";
            state.errorMessageEmail = "";
            state. userMessage = "";
            
        },
       openRecoveryPassForm: (state, action) => {
            state.openRecoveryPassForm = true;
        },
        closeRecoveryPassForm: (state,action) => {
            state.openRecoveryPassForm = false;
            state.errorMessage = "";
            state.errorMessageEmail = "";
            
        },        
        openLoginForm: (state, action) => {
            state.openLoginForm = true;
        },
        validateErrorEmail: (state, action) => {
            state.errorMessageEmail = action.payload;
        },
        validateErrorPassword: (state, action) => {
            state.errorMessagePassword = action.payload;
        },
        validateErrorNickname: (state, action) => {
            state.errorMessageNickname = action.payload;
        },
        closeActivationForm: (state,action) => {
            state.openActivationForm = false;
        },
        clearErrorMessages: (state,action) => {
            state.errorMessage = "";

        },
        clearUserMessages: (state,action) => {
            state.userMessage = "";
            state.userMessageForRecovery = '';

        },
        clearHistoryScore: (state) => {
            state.w_score = 0;
            state.s_score = 0;
            state.c_score = 0;
            state.sumQuizes = 0;
            state.finishedQuizes = [];
            state.favoriteQuizes = [];

        },
        setFindContact: (state, action) => {
            console.log(action.payload);
            const searchArray = [];
            
            searchArray.push(action.payload);
            state.findContact = searchArray;
        }

    },
    extraReducers: (builder) => {
        builder
        //REGISTER User
    .addCase(registerUser.pending, (state, action) => {
        state.isFetching = true;
        state.error = false;
        state.userMessage = 'Загрузка...';
        
    })
    .addCase(registerUser.fulfilled, (state, action) => {
        state.isFetching = true;
         state.isFetchingStatusForRefresh = true;  // FOR APP REFRESH 
       // console.log(action.payload);
        
        if (action.payload === 409) {
            state.errorMessage = 'Такой пользователь уже существует';
            state.userMessage ='';
            console.log('user exist ');
        
       
            
        } else if (action.payload === 410){
            state.errorMessage = 'К сожалению, ник занят, подберите другой.';
            state.userMessage ='';
            console.log('nickname exist ');
        }
        
        else {
            console.log(action.payload);
            state.email = action.payload.user.useremail;
            state.id = action.payload.user.id;
            state.nickName = action.payload.userNickName;
            state.openRegistrationForm = false;
            state.userMessage ='';
            state.usermesCategory = action.payload.user.usermes_category;

           state.accessToken = action.payload.accessToken;
           state.refreshToken = action.payload.refreshToken;
           localStorage.setItem('token', action.payload.accessToken );
           state.username = action.payload.user.username;
           state.publisher = action.payload.publisher;
           state.occupation = action.payload.user.occupation;
           state.subscription = action.payload.user.subscription;
           state.userRole = action.payload.userRole;
           state.modulesName = action.payload.modulesName;

           state.quizes_total = action.payload.sumQuizesTotal;
                           //sumscoreTotal
                           action.payload.sumScoreTotal.forEach(item => {
                            if (item.score_categories === 1) {
                                state.w_total = item.sum;
                            }
                            else if (item.score_categories === 2) {
                                state.s_total = item.sum;
                            }
                            else if (item.score_categories === 3) {
                                state.c_total = item.sum;
                            }
                        }
                            
                            ) 
        }
       
    })
    
    .addCase(registerUser.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        state.errorMessage = 'Сервер временно недоступен';
        state.userMessage ='';
        console.log('bad request!')
    })

    //LOGIN User
    .addCase(loginUser.pending, (state, action) => {
        state.isFetching = true;
        state.error = false;
        state.userMessage = 'Загрузка...';
        
    })
    .addCase(loginUser.fulfilled, (state, action) => {
        state.isFetching = true;
         state.isFetchingStatusForRefresh = true;  // FOR APP REFRESH 
       // console.log(action.payload);
        
        if (action.payload === 404) {
            state.errorMessage = 'Электронная почта или имя пользователя не обнаружены в базе данных.';
            state.userMessage ='';
            console.log('user NOT exist ');
            
        } else if (action.payload === 401) {
                state.errorMessage = 'К сожалению, вы ввели неправильный пароль. Проверьте свой пароль еще раз.';
                state.userMessage ='';
                console.log('wrong password ');
        }
        
        else{
           // console.log(action.payload.favoriteQuizes);
            state.email = action.payload.user.useremail;
            state.id = action.payload.user.id;
            state.avatarName = action.payload.avatarName;
            console.log(action.payload.avatarName);
            state.openLoginForm = false;
            state.userMessage ='';
            state.accessToken = action.payload.accessToken;
            state.refreshToken = action.payload.refreshToken;
           
           localStorage.setItem('token', action.payload.accessToken )
           state.openMainData = true;
           state.isActivated = action.payload.user.isActivated;
           state.nickName = action.payload.userNickName;
           state.username = action.payload.user.username;
           state.publisherName = action.payload.publisherName;
           state.occupation = action.payload.user.occupation;
           state.subscription = action.payload.user.subscription;
           state.usercountry = action.payload.user.usercountry;
           state.id_occupation = action.payload.user.id_occupation;
           state.usermesCategory = action.payload.user.usermes_category;
           state.modulesName = action.payload.modulesName;
            
           //add resolved quiz to favorites if exist 
            if (action.payload.finishedQuizes.length !== 0) {

                const  favoriteQuizesData = [];
                   action.payload.favoriteQuizes.forEach(item => {
                     let resultIndex;
   
                     resultIndex = action.payload.finishedQuizes.findIndex(arg => 
                           item.quiz_id === arg.quiz_id);
                            
                   console.log(resultIndex);
                   if (resultIndex !== -1) {
                       favoriteQuizesData.push({
                           quiz_id:item.quiz_id,
                           quiz_name: item.quiz_name,
                           quiz_resolved: action.payload.finishedQuizes[resultIndex].quiz_resolved,
                           quiz_subcategory:item.sub_name,
                           quiz_category:item.main_name,
                           public:item.public,
                       })
                   } else {
                       favoriteQuizesData.push({
                           quiz_id:item.quiz_id,
                           quiz_name: item.quiz_name,
                           quiz_resolved: null,
                           quiz_subcategory:item.sub_name,
                           quiz_category:item.main_name,
                           public:item.public,
                       })
                   }
                       
                   })
                   console.log(favoriteQuizesData);
                   state.favoriteQuizes = favoriteQuizesData;
               } else {
                   state.favoriteQuizes = action.payload.favoriteQuizes;
               }
   


           state.finishedQuizes = action.payload.finishedQuizes;
           state.userRole = action.payload.userRole;
           state.sumQuizes = action.payload.sumQuizes.count;

           state.quizes_total = action.payload.sumQuizesTotal;
           //contacts-without changing names of res var!!!
           state.contacts =action.payload.contacts;
           console.log(action.payload.contactsGroups);
             
               //FORM CONTACTS GROUPS DATA

               let dataContactsGroups  = action.payload.contactsGroups;   

                let contactsGroups = [];
                if (dataContactsGroups.length !== 0) {
                 dataContactsGroups.forEach((item) => {

                    let result = contactsGroups.findIndex(item2 => item2.id === item.id);
                   // console.log(item);
                   // console.log(result);
                    if (result !== -1) {



                        let user = {
                            username:item.username, 
                            nickname:item.user_nickname, 
                            avatarname:item.user_image_name,
                            id:item.user_id

                        }

                        contactsGroups[result].contacts.push(user);
                        
                    } 
                    else {

                        let newGroup={
                            id: item.id,
                            groupName: item.group_name,
                            contacts: [{
                                username:item.username, 
                                nickname:item.user_nickname, 
                                avatarname:item.user_image_name,
                                id:item.user_id

                            }]
                        };

                        contactsGroups.push(newGroup);


                    };



               });
              // console.log(contactsGroups);
               state.contactsGroups = contactsGroups;
            }
           //state.tasksPublic = action.payload.tasksPublic;
           //state.tasksPrivate = action.payload.tasksPrivate; 


           
           //sumscore
           action.payload.sumScore.forEach(item => {
            if (item.score_categories === 1) {
                state.w_score = item.sum;
            }
            else if (item.score_categories === 2) {
                state.s_score = item.sum;
            }
            else if (item.score_categories === 3) {
                state.c_score = item.sum;
            }
        }
            
            );
                //sumscoreTotal
                action.payload.sumScoreTotal.forEach(item => {
                    if (item.score_categories === 1) {
                        state.w_total = item.sum;
                    }
                    else if (item.score_categories === 2) {
                        state.s_total = item.sum;
                    }
                    else if (item.score_categories === 3) {
                        state.c_total = item.sum;
                    }
                }
                    
                    ) 
        }
       
    })
    
    .addCase(loginUser.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        state.errorMessage = 'Сервер временно недоступен';
        state.userMessage ='';
        console.log('bad request login!')
    })
        // RECOVERY User

    .addCase(recoveryUser.pending, (state, action) => {
        state.isFetching = true;
        state.error = false;
       state.userMessageForRecovery = 'Загрузка...';
        
    })
    .addCase(recoveryUser.fulfilled, (state, action) => {
        state.isFetching = true;
        if (action.payload === 404) {
            state.errorMessage = 'Такого пользователя не существует';
        } else {
            state.errorMessage = '';
            state.userMessage = action.payload;
            state.openRecoveryForm = false;
            state.openLoginForm = true;
            console.log(action);
        }
       
        
      
    })
    
    .addCase(recoveryUser.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        console.log(action);
        state.errorMessage = 'Сервер временно недоступен';
        state.userMessage ='';
        console.log('bad request recovery user!')
    })
        // RECOVERY User PASS

    .addCase(recoveryUserPass.pending, (state, action) => {
        state.isFetching = true;
        state.error = false;
        
        
    })
    .addCase(recoveryUserPass.fulfilled, (state, action) => {
        state.isFetching = true;
        console.log(action);
        
      
    })
    
    .addCase(recoveryUserPass.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        console.log(action);
        state.errorMessage = 'Сервер временно недоступен';
        state.userMessage ='';
        console.log('bad request recovery user PASS!')
    })
        // RECOVERY User PASS FORM

    .addCase(recoveryUserPassForm.pending, (state, action) => {
        state.isFetching = true;
        state.error = false;
       
        
    })
    .addCase(recoveryUserPassForm.fulfilled, (state, action) => {
       // console.log("open pass form");
        state.isFetching = true;
       // state.openRecoveryPassForm = false;
        console.log(action.payload);
        state.userMessageForRecovery = action.payload;
        
      
    })
    
    .addCase(recoveryUserPassForm.rejected, (state, action) => {
        state.isFetching = false;
       // state.error = action.payload;
       // console.log(action);
       // state.errorMessage = 'Сервер временно недоступен';
       // state.userMessage ='';
        console.log('bad request recovery user PASS form!')
    })
    // LOGOUT User

    .addCase(logout.pending, (state, action) => {
        state.isFetching = true;
        state.error = false;
       
        
    })
    .addCase(logout.fulfilled, (state, action) => {
        state.isFetching = true;
        console.log(action);
           localStorage.removeItem('token');
      
    })
    
    .addCase(logout.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
      console.log(action);
        state.errorMessage = 'Сервер временно недоступен';
        state.userMessage ='';
        console.log('bad request logout!')
    })

        //REFRESH
    .addCase(refreshToken.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
            state.userMessage = 'Загрузка...';
            
        })
    .addCase(refreshToken.fulfilled, (state, action) => {
            state.isFetching = true;
            state.isFetchingStatusForRefresh = true;  // FOR APP REFRESH 
           // console.log(action.payload);
            
            if (action.payload === 404) {
                state.errorMessage = 'Электронная почта или имя пользователя не обнаружены в базе данных.';
                state.userMessage ='';
                console.log('user NOT exist ');
                
            } else if (action.payload === 401) {
                    state.errorMessage = 'К сожалению, вы ввели неправильный пароль. Проверьте свой пароль еще раз.';
                    state.userMessage ='';
                    console.log('wrong password ');
            }
            else if (action.payload === 500) {

                state.errorMessage = 'Внутрення ошибка';
                state.userMessage ='';
                console.log('Внутрення ошибка');
            }
            else{
                console.log(action.payload);
                state.email = action.payload.user.useremail;
                state.id = action.payload.user.id;
                state.avatarName = action.payload.avatarName;
                state.openMainData = true;
                state.userMessage ='';
                state.accessToken = action.payload.accessToken;
                state.refreshToken = action.payload.refreshToken;
               
               localStorage.setItem('token', action.payload.accessToken )
              
              state.isActivated = action.payload.user.isActivated;
              state.nickName = action.payload.userNickName;
              state.username = action.payload.user.username;
              state.publisherName = action.payload.publisherName;
              state.occupation = action.payload.user.occupation;
              state.subscription = action.payload.user.subscription;
              state.usercountry = action.payload.user.usercountry;
              state.usermesCategory = action.payload.user.usermes_category;
              state.modulesName = action.payload.modulesName;
              //state.tasksPublic = action.payload.tasksPublic;
              //state.tasksPrivate = action.payload.tasksPrivate;  
             //add resolved quiz to favorites if exist 
             if (action.payload.finishedQuizes.length !== 0) {

             const  favoriteQuizesData = [];
                action.payload.favoriteQuizes.forEach(item => {
                  let resultIndex;

                  resultIndex = action.payload.finishedQuizes.findIndex(arg => 
                        item.quiz_id === arg.quiz_id);
                         
                console.log(resultIndex);
                if (resultIndex !== -1) {
                    favoriteQuizesData.push({
                        quiz_id:item.quiz_id,
                        quiz_name: item.quiz_name,
                        quiz_resolved: action.payload.finishedQuizes[resultIndex].quiz_resolved,
                        quiz_subcategory:item.sub_name,
                        quiz_category:item.main_name,
                        public:item.public,

                    })
                } else {
                    favoriteQuizesData.push({
                        quiz_id:item.quiz_id,
                        quiz_name: item.quiz_name,
                        quiz_resolved: null,
                        quiz_subcategory:item.sub_name,
                        quiz_category:item.main_name,
                        public:item.public,
                    })
                }
                    
                })
               // console.log(favoriteQuizesData);
                state.favoriteQuizes = favoriteQuizesData;
            } else {
                state.favoriteQuizes = action.payload.favoriteQuizes;
            }

              

              
              state.finishedQuizes = action.payload.finishedQuizes;
              state.userRole = action.payload.userRole;
              state.sumQuizes = action.payload.sumQuizes.count;
              //contacts
              state.contacts =action.payload.contacts;  
                             //FORM CONTACTS GROUPS DATA

               let dataContactsGroups  = action.payload.contactsGroups;   

                let contactsGroups = [];
                if (dataContactsGroups.length !== 0) {
                 dataContactsGroups.forEach((item) => {

                    let result = contactsGroups.findIndex(item2 => item2.id === item.id);
                   // console.log(item);
                   // console.log(result);
                    if (result !== -1) {



                        let user = {
                            username:item.username, 
                            nickname:item.user_nickname, 
                            avatarname:item.user_image_name,
                            id:item.user_id

                        }

                        contactsGroups[result].contacts.push(user);
                        
                    } 
                    else {

                        let newGroup={
                            id: item.id,
                            groupName: item.group_name,
                            contacts: [{
                                username:item.username, 
                                nickname:item.user_nickname, 
                                avatarname:item.user_image_name,
                                id:item.user_id

                            }]
                        };

                        contactsGroups.push(newGroup);


                    };



               });
              // console.log(contactsGroups);
               state.contactsGroups = contactsGroups;
            }







              //sumscore
              //console.log(action.payload.sumScore);
              
              action.payload.sumScore.forEach(item => {
                if (item.score_categories === 1) {
                    state.w_score = item.sum;
                }
                else if (item.score_categories === 2) {
                    state.s_score = item.sum;
                }
                else if (item.score_categories === 3) {
                    state.c_score = item.sum;
                }
            }
                
                )
                //sumscoreTotal
                state.quizes_total = action.payload.sumQuizesTotal;

                action.payload.sumScoreTotal.forEach(item => {
                    if (item.score_categories === 1) {
                        state.w_total = item.sum;
                    }
                    else if (item.score_categories === 2) {
                        state.s_total = item.sum;
                    }
                    else if (item.score_categories === 3) {
                        state.c_total = item.sum;
                    }
                }
                    
                    ) 
                
            }
           
        })
        
    .addCase(refreshToken.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            state.errorMessage = 'Сервер временно недоступен';
            state.userMessage ='';
            console.log('bad request login!')
        })
               //REFRESH ACCESS
    .addCase(refreshAccessToken.pending, (state, action) => {
        state.isFetching = true;
        state.error = false;
        state.userMessage = 'Загрузка...';
        
    })
.addCase(refreshAccessToken.fulfilled, (state, action) => {
        state.isFetching = true;
         
       // console.log(action.payload);
        

        if (action.payload === 500) {

            state.errorMessage = 'Внутрення ошибка';
            state.userMessage ='';
            console.log('Внутрення ошибка');
        }
        else{
           
            state.accessToken = action.payload.accessToken;
            state.refreshToken = action.payload.refreshToken;
           
           localStorage.setItem('token', action.payload.accessToken );
          
        
                
                 
            
        }
       
    })
    
.addCase(refreshAccessToken.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        state.errorMessage = 'Сервер временно недоступен';
        state.userMessage ='';
        console.log('bad request login!')
    })
        //UPDATE ACCOUNT
    .addCase(accountUpdate.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
    .addCase(accountUpdate.fulfilled, (state, action) => {
           // console.log(action.payload);
        if (action.payload) {    
            state.username = action.payload.username;
            state.id_occupation = action.payload.id_occupation;
            state.usercountry = action.payload.usercountry;
            state.publisherName = action.payload.publisher;
            state.isFetching = true;
            state.error= false;
           // console.log(typeof(action.payload.id_occupation));

           if (action.payload.id_occupation === 1) {
                state.occupation = "Инженер";
            };
            if (action.payload.id_occupation === 2) {
                //console.log("sdfsdfsfsdfsdfsdffffffffffff");
                state.occupation = "Архитектор";
            };
            if (action.payload.id_occupation === 3) {
                
                state.occupation = "Студент";
            };
            if (action.payload.id_occupation === 4) {
                
                state.occupation = "Пользователь";
            };
        }

        })
    .addCase(accountUpdate.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
         //GET FAVORITE QUIZES
         /*
    .addCase(getFavoriteQuizes.pending, (state, action) => {
                    state.isFetching = true;
                    state.error = false;
                    state.userMessage = 'Загрузка...';
                    
                }) 
    .addCase(getFavoriteQuizes.fulfilled, (state, action) => {
                    state.isFetching = true;
                     
                   // console.log(action.payload);
                    
                    if (action.payload === 404) {
                        state.errorMessage = 'Электронная почта или имя пользователя не обнаружены в базе данных.';
                        state.userMessage ='';
                        console.log('user NOT exist ');
                        
                    } else if (action.payload === 401) {
                            state.errorMessage = 'К сожалению, вы ввели неправильный пароль. Проверьте свой пароль еще раз.';
                            state.userMessage ='';
                            console.log('wrong password ');
                    }
                    else if (action.payload === 500) {
        
                        state.errorMessage = 'Внутрення ошибка';
                        state.userMessage ='';
                        console.log('Внутрення ошибка');
                    }
                    else{
                        console.log(action.payload);
                        state.favoriteQuizes = action.payload;

                    }
                   
    }) 
                
    .addCase(getFavoriteQuizes.rejected, (state, action) => {
                        state.isFetching = false;
                        state.error = action.payload;
                        state.errorMessage = 'Сервер временно недоступен';
                        state.userMessage ='';
                        console.log('bad GET FQ')
                    })
                        */
//ADD FAVORITE QUIZES
     .addCase(addFavoriteQuizes.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
            state.userMessage = 'Загрузка...';
            
        }) 
    .addCase(addFavoriteQuizes.fulfilled, (state, action) => {
            state.isFetching = true;
            console.log(action.payload);
            if (action.payload) {
                const data = action.payload.info[0];


                //IF FAVORITE EXIST IN FINISHED QUIZES
                if (action.payload.answer.length !== 0) {

                    console.log(action.payload.answer);
                    
                    data.quiz_resolved = action.payload.answer[0].quiz_resolved;
                    console.log(data);
                


                 //ADD TO THE STATE Fav QUIZ IF THERE IS NO ONE IN THE STATE   
                 let result =   state.favoriteQuizes.findIndex(item => item.quiz_id === action.payload.data[0].quiz_id);
                    if (result !== -1) { 
                        console.log('includes!!!!' + action.payload.data[0].quiz_id);
                        state.favoriteQuizes[result].quiz_resolved = action.payload.answer[0].quiz_resolved;
                    } else {
                        state.favoriteQuizes.push(data);
                        console.log('NOTincludes!!!!');
                    }
                } else {
                    //ADD TO THE STATE Fav QUIZ IF THERE IS NO ONE IN THE STATE   
                    let result =   state.favoriteQuizes.findIndex(item => item.quiz_id === action.payload.data[0].quiz_id);
                    if (result !== -1) { 
                    console.log('includes!!!!' + action.payload.data[0].quiz_id);
                    state.favoriteQuizes[result].quiz_resolved = null;
                } else {
                        data.quiz_resolved = null;
                        state.favoriteQuizes.push(data);
                        console.log('NOTincludes!!!!');
                    }
                // data.quiz_resolved = 666;
                }

            }
        
    }) 
        
    .addCase(addFavoriteQuizes.rejected, (state, action) => {
                state.isFetching = false;
                state.error = action.payload;
                state.errorMessage = 'Сервер временно недоступен';
                state.userMessage ='';
                console.log('bad add FQ')
            })
//DELETE FAVORITE QUIZES
.addCase(deleteFavoriteQuizes.pending, (state, action) => {
    state.isFetching = true;
    state.error = false;
    state.userMessage = 'Загрузка...';
    
}) 
.addCase(deleteFavoriteQuizes.fulfilled, (state, action) => {
    state.isFetching = true;
    if (action.payload) {
        const index = state.favoriteQuizes.findIndex(item => 
            item.quiz_id ===action.payload[0].quiz_id);
        state.favoriteQuizes.splice(index,1);
        }
}) 

.addCase(deleteFavoriteQuizes.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        state.errorMessage = 'Сервер временно недоступен';
        state.userMessage ='';
        console.log('bad add FQ')
    })

            //ADD QUIZ RESULT
        .addCase(addQuizResult.pending, (state, action) => {
            console.log(action.payload);
                state.isFetching = true;
                state.error = false;
                state.userMessage = 'Загрузка...';
                
            }) 
        .addCase(addQuizResult.fulfilled, (state, action) => {
                    state.isFetching = true;
                    if (action.payload) {
                    


                 //ADD TO THE STATE FINISHED QUIZ IF THERE IS NO ONE IN THE STATE   
                if (action.payload.answer.length !== 0) {

                    console.log(action.payload.answer);
                    const data = action.payload.info[0];
                    data.quiz_resolved = action.payload.answer[0].quiz_resolved;
                    console.log(data);
                
                     // ADD RESULT TO FAVORITES QUIZES  
                    let checkIfExistinFavorites =   state.favoriteQuizes.findIndex(item => item.quiz_id === action.payload.answer[0].quiz_id);
                    if (checkIfExistinFavorites !== -1) { 
                    console.log('includes IN FAVORITES!!!!' + action.payload.answer[0].quiz_id);
                    state.favoriteQuizes[checkIfExistinFavorites].quiz_resolved = action.payload.answer[0].quiz_resolved;
                    }

                // RESULT TO FINISHED QUIZES
                    let result =   state.finishedQuizes.findIndex(item => item.quiz_id === action.payload.answer[0].quiz_id);
                    console.log(result);
                    if (result !== -1) { 
                        console.log('includes IN finished!!!!' + action.payload.answer[0].quiz_id);
                        state.finishedQuizes[result].quiz_resolved = action.payload.answer[0].quiz_resolved; 
                    } 
                    else {
                        
                        state.finishedQuizes.push(data);
                        console.log('NOTincludes!!!!');
                    }

                    //ADD SUM QUIZES WHICH RESULT 100%       
                    if (Number(action.payload.answer[0].quiz_resolved) === 100) {
                        
                        state.sumQuizes++;
                        console.log(action.payload.score);
                        if (action.payload.score) {
                              action.payload.score.forEach(item => {
                                if (item.score_categories === 1) {
                                    state.w_score = item.sum;
                                }
                                else if (item.score_categories === 2) {
                                    state.s_score = item.sum;
                                }
                                else if (item.score_categories === 3) {
                                    state.c_score = item.sum;
                                }
                            }
                          
                                )
                        
                       }

                    } 
                }
            }
        }) 
        
        .addCase(addQuizResult.rejected, (state, action) => {
                    state.isFetching = false;
                    state.error = action.payload;
                    state.errorMessage = 'Сервер временно недоступен';
                    state.userMessage ='';
                    console.log('bad add Result Q')
                }) 
            //ADD USER SCORE 
             /* 
        .addCase(addUserScore.pending, (state, action) => {
                console.log(action.payload);
                    state.isFetching = true;
                    state.error = false;
                    state.userMessage = 'Загрузка...';
                    
                }) 
              
         .addCase(addUserScore.fulfilled, (state, action) => {
                        state.isFetching = true;
                        console.log(action.payload);
                if (action.payload) {
                      action.payload.map(item => {
                        if (item.score_categories === 1) {
                            state.w_score = item.sum;
                        }
                        else if (item.score_categories === 2) {
                            state.s_score = item.sum;
                        }
                        else if (item.score_categories === 3) {
                            state.c_score = item.sum;
                        }
                    }
                  
                        )
                }
            }) 
            
        .addCase(addUserScore.rejected, (state, action) => {
                        state.isFetching = false;
                        state.error = action.payload;
                        state.errorMessage = 'Сервер временно недоступен';
                        state.userMessage ='';
                        console.log('bad add Score Q')
                    })*/

                            //UPLOAD AVATAR
        .addCase(uploadAvatar.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
            state.userMessage = 'Загрузка...';
        })

        
        .addCase(uploadAvatar.fulfilled, (state, action) => {
            console.log(action.payload);
            state.isFetching = true;
            state.error = false;
            if (action.payload || action.payload !== 401) {
            
            state.avatarName.user_image_name = action.payload.filename;
        }
        })
        .addCase(uploadAvatar.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
        })
             //DELETE AVATAR
             .addCase(deleteAvatar.pending, (state, action) => {
                state.isFetching = true;
                state.error = false;
                state.userMessage = 'Загрузка...';
            })
            .addCase(deleteAvatar.fulfilled, (state, action) => {
                console.log(action.payload);
               // if (action.payload)  {
                console.log(action.payload);
                state.isFetching = true;
                state.error = false;
                state.avatarName.user_image_name = '';
                //}
              
            })
            .addCase(deleteAvatar.rejected, (state, action) => {
                state.isFetching = false;
                state.error = action.payload;
            })
        //FIND CONTACT
        .addCase(findContact.pending, (state) => {
            state.userMessage = 'Загрузка...';
        })
        .addCase(findContact.fulfilled, (state, action) => {
            console.log(action.payload);
            state.isFetching = true;
            state.error = false;
            if (action.payload) {

            
            if (action.payload ===404) {
                
                state.errorMessage = action.payload;
                state.userMessage = 'Пользователь не найден.';
                state.findContact = [];
            } else
            state.findContact = action.payload;
        }
        })
        .addCase(findContact.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
        })
        //DELETE CONTACT
        .addCase(deleteContact.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
            state.userMessage = 'Загрузка...';
            
        }) 
        .addCase(deleteContact.fulfilled, (state, action) => {
            state.isFetching = true;
               // console.log(action.payload);
               if (action.payload || action.payload.length !== 0) {
                const index = state.contacts.findIndex(item => 
                    item.id === action.payload[0].id);
               // console.log(index);
                state.contacts.splice(index,1);
                }
        }) 

        .addCase(deleteContact.rejected, (state, action) => {
                state.isFetching = false;
                state.error = action.payload;
                state.errorMessage = 'Сервер временно недоступен';
                state.userMessage ='';
                console.log('bad delete contact');
            })
            // ADD CONTACT
            .addCase(addContact.pending, (state) => {
                state.isFetching = true;
                state.error = false;
                state.userMessage = 'Загрузка...';
            })
            .addCase(addContact.fulfilled, (state, action) => {
                if (action.payload) {
                if (action.payload === 409) {
                    console.log('user is already exist');
                } 
                else {

                
                console.log('add contact good!');
                state.contacts.push(action.payload[0]);
                }
               
            }
            })
            .addCase(addContact.rejected, (state,action) => {
                state.isFetching = false;
                state.error = action.payload;
                state.errorMessage = 'Сервер временно недоступен';
                state.userMessage ='';
                console.log('bad add contact');
            })
             //CONFIRM CONTACT
        .addCase(confirmContact.pending, (state) => {
            state.userMessage = 'Загрузка...';
        })
        .addCase(confirmContact.fulfilled, (state, action) => {
            console.log(action.payload);
            state.isFetching = true;
            state.error = false;
            if (action.payload) {
            if (action.payload === 404) {
                
                state.errorMessage = action.payload;
                state.userMessage = 'Пользователь не найден.';
               
            } else {
                console.log('add contact good!'); 
                state.contacts.push(action.payload[0]);
            }
       }
        })
        .addCase(confirmContact.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
        })
                    // ADD GROUP CONTACT
            .addCase(addGroupContact.pending, (state) => {
                state.isFetching = true;
                state.error = false;
                state.userMessage = 'Загрузка...';
            })
            .addCase(addGroupContact.fulfilled, (state, action) => {
                if (action.payload) {
                if (action.payload === 409) {
                   // console.log('group is already exist');
                    state.errorMessageGroupContact = 'Такая группа уже существует. Задайте другое имя.'
                } 
                else {

                state.errorMessageGroupContact = '';
               // console.log('add group contact good!');
                 const newGroup = action.payload;

                state.contactsGroups.push(newGroup);
                }
               
            }
            })
            .addCase(addGroupContact.rejected, (state,action) => {
                state.isFetching = false;
                state.error = action.payload;
                state.errorMessage = 'Сервер временно недоступен';
                state.userMessage ='';
                console.log('bad add group contact');
            })

            //ADD USER TO GROUP
   
            .addCase(addUserGroupContact.pending, (state) => {
                state.isFetching = true;
                state.error = false;
                state.userMessage = 'Загрузка...';
            })
            .addCase(addUserGroupContact.fulfilled, (state, action) => {
                if (action.payload) {
                if (action.payload === 409) {
                   // console.log('group is already exist');
                    state.errorMessageUserGroupContact = 'Такой пользователь уже есть в этой группе'
                } 
                else {

                state.errorMessageUserGroupContact = '';
               // console.log('add group contact good!');
                 const newUser = action.payload.contacts[0];

                  const index = state.contactsGroups.findIndex(item => 
                        item.id === action.payload.id);

                state.contactsGroups[index].contacts.push(newUser);
                }
               
            }
            })
            .addCase(addUserGroupContact.rejected, (state,action) => {
                state.isFetching = false;
                state.error = action.payload;
                state.errorMessage = 'Сервер временно недоступен';
                state.userMessage ='';
                console.log('bad add group contact');
            })
        
        //ADD MESSAGE

            .addCase(addMessage.pending, (state) => {
                state.isFetching = true;
                state.error = false;
                state.userMessage = 'Загрузка...';
            })
            .addCase(addMessage.fulfilled, (state, action) => {

                // STATE NOWHERE BE USED!!!!- SEE MESSAGESLICE
                if (action.payload) {
                    const res = action.payload[0];
                    console.log('add message good!');
                    state.messages.push(res);
            }
                }
                           
            )
            .addCase(addMessage.rejected, (state,action) => {
                state.isFetching = false;
                state.error = action.payload;
                state.errorMessage = 'Сервер временно недоступен';
                state.userMessage ='';
                console.log('bad get MESSAGE');
            })
            //GET ALL MESSAGES

            .addCase(getAllMessages.pending, (state) => {
                state.isFetching = true;
                state.error = false;
                state.userMessage = 'Загрузка...';
            })
            .addCase(getAllMessages.fulfilled, (state, action) => {
                
                console.log('get all messages!');
               
                    state.messages = action.payload;
                
                
                }
                        
            )
            .addCase(getAllMessages.rejected, (state,action) => {
                state.isFetching = false;
                state.error = action.payload;
                state.errorMessage = 'Сервер временно недоступен';
                state.userMessage ='';
                console.log('bad get all MESSAGE');
            })
            //DELETE MESSAGE
            .addCase(deleteMessage.pending, (state, action) => {
                state.isFetching = true;
                state.error = false;
                state.userMessage = 'Загрузка...';
                
            }) 
            .addCase(deleteMessage.fulfilled, (state, action) => {
                state.isFetching = true;
                console.log(action.payload);
                if (action.payload) {
                const index = state.messages.findIndex(item => 
                        item.id === action.payload.id);
                        console.log(index);
                state.messages.splice(index,1);
            }
            }) 

            .addCase(deleteMessage.rejected, (state, action) => {
                    state.isFetching = false;
                    state.error = action.payload;
                    state.errorMessage = 'Сервер временно недоступен';
                    state.userMessage ='';
                    console.log('bad delete message');
                })
            //DELETE GROUP CONTACT
        .addCase(deleteGroupContact.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
            state.userMessage = 'Загрузка...';
            
        }) 
        .addCase(deleteGroupContact.fulfilled, (state, action) => {
            state.isFetching = true;
               // console.log(action.payload);
               if (action.payload || action.payload.length !== 0) {
                const index = state.contactsGroups.findIndex(item => 
                    item.id === action.payload[0].id);
               // console.log(index);
                state.contactsGroups.splice(index,1);
                }
        }) 

        .addCase(deleteGroupContact.rejected, (state, action) => {
                state.isFetching = false;
                state.error = action.payload;
                state.errorMessage = 'Сервер временно недоступен';
                state.userMessage ='';
                console.log('bad delete contact');
            })
    //UPDATE NAME GROUP CONTACT
        .addCase(updateNameGroupContact.pending, (state, action) => {
                state.isFetching = true;
                state.error = false;
            })
        .addCase(updateNameGroupContact.fulfilled, (state, action) => {
             console.log(action.payload);
            if (action.payload) {    
                const index = state.contactsGroups.findIndex(item => 
                item.id === action.payload.id);
                state.contactsGroups[index].groupName = action.payload.group_name;

                state.isFetching = true;
                state.error= false;
          
            }

            })
        .addCase(updateNameGroupContact.rejected, (state, action) => {
                state.isFetching = false;
                state.error = action.payload;
                console.log("oh wrong!!!");
            })
            //DELETE USER FROM GROUP CONTACT
        .addCase(userDeleteFromGroup.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
            state.userMessage = 'Загрузка...';
            
        }) 
        .addCase(userDeleteFromGroup.fulfilled, (state, action) => {
            state.isFetching = true;
               // console.log(action.payload);
               if (action.payload || action.payload.length !== 0) {
                const indexGroup = state.contactsGroups.findIndex(item => 
                item.id === action.payload.group_id);

                console.log(indexGroup);
                const indexContact = state.contactsGroups[indexGroup].contacts.findIndex(item => 
                item.id === action.payload.user_id);

                console.log(indexContact);
                state.contactsGroups[indexGroup].contacts.splice(indexContact,1);
                }
        }) 

        .addCase(userDeleteFromGroup.rejected, (state, action) => {
                state.isFetching = false;
                state.error = action.payload;
                state.errorMessage = 'Сервер временно недоступен';
                state.userMessage ='';
                console.log('bad delete contact');
            })



    }
    

};
export const authSlice = createSlice(options);
export const {openRegistrationForm, closeRegistrationForm,
    activeLoginForm, validateErrorPassword, 
    validateErrorEmail, openLoginForm, closeLoginForm, 
    clearErrorMessages, closeActivationForm,
    getInitialState, clearHistoryScore, validateErrorNickname, 
    setFindContact, closeRecoveryForm, openRecoveryForm,
openRecoveryPassForm, closeRecoveryPassForm, clearUserMessages } = authSlice.actions;
export default authSlice.reducer;
                                                                          